export default "/_next/static/images/AppleStoreImage-a4859594925341821e1518db196edfa3.png";